<template>
  <div id="main-content" class="parent-template-detail">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <el-row>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item>
            <el-button type="success" @click="goToEdit()">{{ $t('common.edit') }}</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <form v-if="parentNotificationTemplateInfo">
        <el-row>
          <el-col :span="24">
            <span class="form-lable">{{ $t('common.title') }}:</span>
            <span class="info-span"> {{ parentNotificationTemplateInfo.title }} </span>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="24">
            <span class="form-lable">{{ $t('common.header') }}:</span>
            <span class="info-span">{{ parentNotificationTemplateInfo.header }}</span>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="24">
            <span class="form-lable">{{ $t('common.footer') }}:</span>
            <span class="info-span">{{ parentNotificationTemplateInfo.footer }}</span>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px" v-if="parentNotificationTemplateInfo.reason_list.length">
          <el-col :span="24">
            <span class="form-lable">{{ $t('notification.reason_list') }}:</span>
            <el-col :span="20" class="reason-list">
              <el-row v-for="(reason, index) in parentNotificationTemplateInfo.reason_list" :key="index">
                <el-col :span="2" class="label">{{ $t('common.title') }}</el-col>
                <el-col :span="6">
                  {{ reason.title }}
                </el-col>
                <el-col :span="2" :offset="2" class="label">{{ $t('common.type') }}</el-col>
                <el-col :span="6">
                  {{ getType(reason.type) }}
                </el-col>
              </el-row>
            </el-col>
          </el-col>
        </el-row>
      </form>
    </el-col>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import PageTitle from '@/components/PageTitle'
  import {
    NOTIFICATION_TEMPLATE_REASON_STRING,
    NOTIFICATION_TEMPLATE_REASON_DATE,
    NOTIFICATION_TEMPLATE_REASON_TEXT_BOX
  } from '@/config'

  export default {
    name: "DetailParentNotificationTemplate",
    components: {
      PageTitle
    },
    data: function () {
      return {
        backLink: `/parent-notification-template?action=back`,
        title: 'notification.parent_notification_template_information'
      }
    },
    mounted: function () {
      let successCallback = () => {
      };
      let payload = {
        successCallback,
        parent_notification_template_id: this.$route.query.tid
      }
      this.$store.dispatch('parentnotificationtemplate/getParentNotificationTemplateInfo', payload)
    },
    computed: {
      ...mapState('parentnotificationtemplate', ['parentNotificationTemplateInfo']),
    },
    methods: {
      goToEdit: function () {
        this.$router.push({path: '/parent-notification-template/edit', query: {tid: this.$route.query.tid}});
      },
      getType (type) {
        switch (type) {
          case NOTIFICATION_TEMPLATE_REASON_STRING:
            return this.$t('common.text')
          case NOTIFICATION_TEMPLATE_REASON_DATE:
            return this.$t('common.date')
          case NOTIFICATION_TEMPLATE_REASON_TEXT_BOX:
            return this.$t('common.text_box')
          default:
            return ''
        }
      }
    }
  }
</script>

<style lang="scss">
  .parent-template-detail {
    .reason-list {
      text-align: left;

      .el-row {
        line-height: 40px;

        .label {
          font-weight: bold;
        }
      }
    }
  }
</style>
